class TitleBarController {
    constructor($state, crConstants) {
        this.$state = $state;
        this.crConstants = crConstants;
    }
}

export default TitleBarController;
